import { createApp } from 'vue';
import App from './App.vue'
import router from './router'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.config.productionTip = false
//app.config.errorHandler = () => null;
//app.config.warnHandler = () => null;

app.use(ElementPlus)
app.use(router)
app.mount('#app')
